<div class="my-5">
  <div class="card">
    <h3 class="card-title">{{ 'actividad' | translate }}</h3>
    <div class="card-body">
      <app-power-bi-embed
        *ngIf="renderizarReporte"
        [embedUrl]="embedUrl"
        [embebedToken]="embedToken"
        [reportId]="reportId"
        [isMobile]="true"
        [heigth]="'300px'"
        [groupId]="groupId"
        [accessToken]="accessToken">
      </app-power-bi-embed>
    </div>
  </div>
</div>
